<script>
	import Head from  "$lib/sections/Head.svelte";
	import PageBanner from  "$lib/sections/PageBanner.svelte";
	import SideBySide from  "$lib/sections/SideBySide.svelte";
	import Features from  "$lib/sections/Features.svelte";

	export let data;

	let lang;
	$: lang = data.lang;

	let area;
	$: area = data.area;

	const col = "about";
</script>

<Head {data} {lang} {area} {col} settingId={"Head"} />

<PageBanner {data} {lang} {area} {col} settingId={"PageBanner"} />

<SideBySide {data} {lang} {area} {col} settingId={"SideBySide 01"} />

<SideBySide {data} {lang} {area} {col} settingId={"SideBySide 02"} />

<Features {data} {lang} {area} {col} settingId={"Features 01"} />
